import { render, staticRenderFns } from "./InfrastructureResources.vue?vue&type=template&id=815e74ec&scoped=true&"
import script from "./InfrastructureResources.vue?vue&type=script&lang=ts&"
export * from "./InfrastructureResources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e74ec",
  null
  
)

export default component.exports